module.exports = __webpack_public_path__ + "img/template-1.cc1a15cd.jpg";